// client/src/api/contractUtils.js
// Utilities for working with the strict API response contract.

/**
 * Unwrap a strict success payload { success: true, data: ... } to just `data`.
 * Falls through unchanged for any non-strict payload so callers remain
 * backward-compatible during gradual migration.
 */
export function unwrapStrictData(payload) {
  if (
    payload?.success === true &&
    Object.prototype.hasOwnProperty.call(payload, 'data')
  ) {
    return payload.data
  }
  return payload
}

/**
 * Unwrap a strict error payload { success: false, error: ... } to just `error`.
 * Falls through unchanged for non-strict payloads.
 */
export function unwrapStrictError(payload) {
  if (payload?.success === false && payload.error) {
    return payload.error
  }
  return payload
}
